import { getDeepValue } from '../utils/help-functions.js';
import { DataTypes } from './DataTypes.js';
import { Comparators } from './Comparators.js';
export class TableColumn {
  constructor(options) {
    this.label = '';
    this.source = '';
    this.dataType = DataTypes.string;
    this.visible = true;
    this.sortable = false;
    this.showInColumnChooser = true;
    this.allowFiltering = true;
    this.cellRenderer = null;
    this.searchRenderer = null;
    this.valueParser = null;
    this.dataSource = null;
    this.alignment = 'left';
    this.style = {};
    this.labelSort = '';
    this.defaultComparator = Comparators.EQUAL.name;
    this.comparators = [];
    this.hidden = false;
    this.mandatory = false;
    Object.assign(this, options);
  }
  parseValue(data) {
    const value = this.getValue(data);
    if (this.valueParser && typeof this.valueParser === 'function') {
      return this.valueParser(value, data);
    }
    if (DataTypes.datetime === this.dataType && value) {
      return new Date(value).toLocaleDateString();
    }
    if (this.dataType === DataTypes.number) return value;
    return value || '';
  }
  getValue(data = {}) {
    return this.source ? getDeepValue(data, this.source) : null;
  }
}